import { type FC } from "react";
import { Modal, Button } from "antd";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../../shared/utils/translationUtils";

export interface BackConfirmationModalProps {
  open: boolean;
  onOk: () => void;
  onCancel: () => void;
  savesCurrentDesign?: boolean;
}

const BackConfirmationModal: FC<BackConfirmationModalProps> = ({
  open,
  onOk,
  onCancel,
  savesCurrentDesign = false,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      title={formatTranslation(t("modal.goBackToListHeaderTrail"))}
      onOk={onOk}
      onCancel={onCancel}
      footer={(_, { OkBtn, CancelBtn }) => (
        <>
          <Button onClick={onCancel}>
            {formatTranslation(t("modal.cancel"))}
          </Button>
          <Button className="ct-bg-red ct-text-white" onClick={onOk}>
            {formatTranslation(t("modal.leavePage"))}
          </Button>
        </>
      )}
    >
      <p>
        {formatTranslation(
          t(
            savesCurrentDesign
              ? "modal.goBackToListSaveDesign"
              : "modal.goBackToList"
          )
        )}
      </p>
      <p>{formatTranslation(t("modal.goBackToListFooter"))}</p>
    </Modal>
  );
};

export default BackConfirmationModal;
